import { gql } from "gql";
import { HealthMetricSource, Policy } from "gql/graphql";
import { apolloClient } from "./apolloClient";
import { captureException } from "src/utils/error";
import { trackEvent } from "src/utils/api/tracker";
import { getInAppAutoCookie } from "src/utils/authCookieParser";

export const ASSESSMENT_PRIVACY_POLICY = gql(`
  query AssessmentPrivacyPolicy($accessCode: String, $assessmentType: HealthMetricSource!) {
    assessmentPrivacyPolicy(accessCode: $accessCode, assessmentType: $assessmentType)
  }
`);

export async function queryAssessmentPrivacyPolicy(
  assessmentType: HealthMetricSource
): Promise<Policy | null> {
  const { accessCode } = getInAppAutoCookie();

  try {
    const variables = accessCode
      ? { accessCode, assessmentType }
      : { assessmentType };

    const result = await apolloClient.query({
      query: ASSESSMENT_PRIVACY_POLICY,
      variables,
    });

    if (!result.data?.assessmentPrivacyPolicy) {
      throw new Error(`No assessment privacy policy for ${accessCode}`);
    }

    return result.data.assessmentPrivacyPolicy;
  } catch (error) {
    trackEvent("OnAssessmentPrivacyPolicyAPIError", {
      error: error.message,
      accessCode,
    });
    captureException(
      error,
      "error-query-assessment-privacy-policy",
      accessCode
    );
    return null;
  }
}
